import React from 'react';

export function Heading({ className = '', level = 2, children, ...props }) {
  const Tag = `h${level}`;
  return (
    <Tag
      className={`text-xl font-semibold text-zinc-950 dark:text-white ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
}

export default Heading; 